(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nm-campaign"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('nm-campaign'))customElements.define('nm-campaign',class extends HTMLElement{connectedCallback(){this.slides=[...this.querySelectorAll('.nm-slide')];this.dots=[...this.querySelectorAll('[data-slide]')];this.index=0;this.paused=this.dataset.autoplay!=='true'||matchMedia('(prefers-reduced-motion: reduce)').matches;this.dots.forEach(b=>b.addEventListener('click',()=>this.show(Number(b.dataset.slide))));this.querySelector('.nm-pause')?.addEventListener('click',e=>{this.paused=!this.paused;e.currentTarget.textContent=this.paused?'▶':'Ⅱ';e.currentTarget.setAttribute('aria-pressed',String(this.paused))});this.timer=setInterval(()=>{if(!this.paused&&!this.matches(':hover')&&!this.contains(document.activeElement)&&!document.hidden)this.show((this.index+1)%this.slides.length)},6500);this.onBlock=e=>{const i=this.slides.findIndex(s=>s.contains(e.target)||s===e.target);if(i>=0){this.show(i);this.paused=true}};this.addEventListener('shopify:block:select',this.onBlock)}show(i){this.index=i;this.slides.forEach((s,j)=>s.hidden=j!==i);this.dots.forEach((b,j)=>b.setAttribute('aria-pressed',String(j===i)))}disconnectedCallback(){clearInterval(this.timer)} });

  } catch(e) { console.error(e); }
})();
})();
